/** US letter unless the page's real width / height is known. */
export const PageSkeleton = ({ aspectRatio = 8.5 / 11 }: { aspectRatio?: number }) => (
    <div style={{ aspectRatio }} className="w-full animate-pulse rounded bg-gray-200" />
);
